import { Link } from "react-router-dom";
import MangaCard from "@/components/base/MangaCard";
import { mangas } from "@/mocks/manga";

export default function LatestUpdates() {
  const latestMangas = [...mangas].sort((a, b) => {
    if (a.updatedAt > b.updatedAt) return -1;
    if (a.updatedAt < b.updatedAt) return 1;
    return 0;
  }).slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 rounded-full bg-accent-500"></div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">
              最新更新
            </h2>
          </div>
          <Link
            to="/category/korean"
            className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latestMangas.map((manga) => (
            <MangaCard key={manga.id} {...manga} />
          ))}
        </div>
      </div>
    </section>
  );
}